/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_1Inputs */

const en_pc_tut_save_1 = /** @type {(inputs: Pc_Tut_Save_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press ⌘S to save. Changes are appended and the original bytes stay intact.`)
};

const zh_pc_tut_save_1 = /** @type {(inputs: Pc_Tut_Save_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 ⌘S 保存。更改会被追加，原始字节保持不变。`)
};

/**
* | output |
* | --- |
* | "Press ⌘S to save. Changes are appended and the original bytes stay intact." |
*
* @param {Pc_Tut_Save_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_1 = /** @type {((inputs?: Pc_Tut_Save_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_1(inputs)
	return zh_pc_tut_save_1(inputs)
});
export { pc_tut_save_1 as "pc.tut.save.1" }